/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, message, Popconfirm } from "antd";
import { ColumnsType } from "antd/lib/table";
import dayjs from "dayjs";

import { getSupaClient, getWorkspace } from "../../lib/supabase";
import SavedSurvey, { SurveyResponse } from "./SurveyResultsTab.type";

/**
 * Removing survey as template
 */
const removeAsTemplate = async (
  survey: SavedSurvey,
  onRemoveTemplate: () => Promise<void>
) => {
  const supabase = getSupaClient();
  const { data, error } = await supabase
    .from("saved_surveys")
    .update({ is_template: false })
    .match({ id: survey.id });
  if (error) {
    message.error("Error removing");
  }
  if (data) {
    message.success("Removed as template!");
    onRemoveTemplate();
  }
};

export const getSavedSurveysColumns = (
  onColumnClick: (savedSurvey: SavedSurvey) => Promise<void>,
  onRemoveTemplate: () => Promise<any>
): ColumnsType<SavedSurvey> => [
  {
    title: "Created",
    dataIndex: "created_at",
    width: "20%",
    key: "created_at",
    render: (_, record: SavedSurvey) =>
      dayjs(record.created_at).format("DD-MMM, HH:mm"),
    sorter: (a: SavedSurvey, b: SavedSurvey) =>
      dayjs(a.created_at).unix() - dayjs(b.created_at).unix(),
  },
  {
    title: "Name",
    dataIndex: "name",
    width: "50%",
    key: "name",
    render: (_, record: SavedSurvey) => (
      <button
        onClick={() => onColumnClick(record)}
        onKeyPress={() => onColumnClick(record)}
        type="button"
      >
        {record.name}
      </button>
    ),
  },
  {
    title: "Actions",
    dataIndex: "is_template",
    width: "30%",
    filters: [{ text: "Only templates", value: true }],
    onFilter: (value, record) => record.is_template === value,
    key: "actions",
    render: (_, record: SavedSurvey) => {
      return (
        <div className="flex space-x-4">
          <Button
            size="small"
            type="primary"
            onClick={() => onColumnClick(record)}
            onKeyPress={() => onColumnClick(record)}
          >
            View results
          </Button>
          {record.is_template ? (
            <Popconfirm
              title="Are you sure to remove as a template?"
              onConfirm={() => removeAsTemplate(record, onRemoveTemplate)}
              onCancel={() => console.log("Cancel")}
              okText="Yes"
              cancelText="No"
            >
              <a href="#">
                <Button size="small">Remove as template</Button>
              </a>
            </Popconfirm>
          ) : null}
        </div>
      );
    },
  },
];

export const getSurveyResponsesColums = (): ColumnsType<SurveyResponse> => [
  {
    title: <p className="truncate">Time</p>,
    dataIndex: "created_at",
    fixed: "left",
    key: "created_at",
    render: (_, record: any) => {
      return dayjs(record.responses[0].created_at).format("DD-MMM, HH:mm");
    },
    sorter: (a: SurveyResponse, b: SurveyResponse) =>
      dayjs(a.created_at).unix() - dayjs(b.created_at).unix(),
    width: 200,
  },
  {
    title: <p className="truncate">Member</p>,
    dataIndex: "slack_users.name",
    fixed: "left",
    key: "slack_user",
    render: (_: string, record: SurveyResponse) => (
      <p className="truncate">{record.slack_users.name}</p>
    ),
    width: 200,
  },
];
